import { Box, Typography } from "@mui/material";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Title,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Title, ChartDataLabels);

const Chart360 = ({ values, question, color, index, labels }) => {

  const mapValueToLabel = (value) => {
    if (!value || value === 0) return "";
    if (value <= 37) return "Not Confident";
    if (value <= 62) return "Somewhat Confident";
    if (value <= 87) return "Confident";
    return "Very Confident";
  };

  const getConfidenceColor = (value) => {
    if (!value || value === 0) return "#BDBDBD";
    if (value <= 37) return "#E53935";   // Not Confident - red
    if (value <= 62) return "#FB8C00";   // Somewhat Confident - orange
    if (value <= 87) return "#1E88E5";   // Confident - blue
    return "#43A047";                    // Very Confident - green
  };

  const chartData = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: values.map(v => getConfidenceColor(v)),
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (context) => mapValueToLabel(context.raw) || "No Response",
        },
      },
      datalabels: {
        color: "#FFFFFF",
        font: { size: 12, weight: "bold" },
        anchor: "center",
        align: "center",
        formatter: (value) => mapValueToLabel(value),
      },
    },
    scales: {
      x: {
        type: "linear",
        min: 0,
        max: 100,
        ticks: {
          stepSize: 25,
          callback: (value) => {
            const tickLabels = {
              0: "",
              25: "Not Confident",
              50: "Somewhat Confident",
              75: "Confident",
              100: "Very Confident",
            };
            return tickLabels[value] || "";
          },
          font: { size: 10 },
          color: "#555",
        },
        grid: {
          color: "rgba(0, 0, 0, 0.15)",
          lineWidth: 1.5,
        },
      },
      y: {
        type: "category",
        ticks: {
          font: { size: 14, weight: "bold" },
          color: "#333",
        },
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <Box sx={{ width: "100%", maxWidth: 800, mx: "auto", mb: 3 }}>
      <Typography color={color} variant="subtitle1" fontWeight={700} textAlign="center" sx={{ mb: 1 }}>
        {index + 1}. {question}
      </Typography>
      <Box sx={{ height: 200 }}>
        <Bar data={chartData} options={options} />
      </Box>
    </Box>
  );
};

export default Chart360;